import formattedValue from '@/helpers/formattedValue'

export default function (tooltipModel) {
  // Tooltip Element
  var tooltipEl = document.getElementById('chartjs-tooltip')

  // Create element on first render
  if (!tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.id = 'chartjs-tooltip'
    tooltipEl.innerHTML = '<div></div>'
    document.body.appendChild(tooltipEl)
  }

  // Hide if no tooltip
  if (tooltipModel.opacity === 0) {
    tooltipEl.style.opacity = 0
    return
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform')
  if (tooltipModel.yAlign) {
    tooltipEl.classList.add(tooltipModel.yAlign)
  } else {
    tooltipEl.classList.add('no-transform')
  }

  function getBody(bodyItem) {
    return bodyItem.lines
  }

  // Set Text
  if (tooltipModel.body) {
    var titleLines = tooltipModel.title || []
    var bodyLines = tooltipModel.body.map(getBody)

    var innerHtml = ''
    titleLines.forEach(function (title) {
      innerHtml +=
        '<div class="font-bold w-full text-center pb-2 text-sm">' +
        title +
        '</div>'
    })

    var cols = 1
    if (bodyLines.length > 10) {
      cols = 2
    } else if (bodyLines.length > 30) {
      cols = 3
    }

    innerHtml += `<div class="grid grid-cols-${cols} gap-2">`
    bodyLines.forEach(function (body, i) {
      var label = body[0].split(': ')
      var colors = tooltipModel.labelColors[i]

      var style = 'background:' + colors.backgroundColor
      style += '; border-color:' + colors.borderColor
      style += '; border-width: 2px'

      var span = '<span class="w-4 h-4 block" style="' + style + '"></span>'
      var newBody = `<span>${body}</span>`
      innerHtml +=
        '<div class="flex space-x-0 space-y-2 lg:space-x-2 lg:space-y-0">' +
        span +
        newBody +
        '</div>'
    })
    innerHtml += '</div>'

    var tableRoot = tooltipEl.querySelector('div')
    tableRoot.innerHTML = innerHtml
  }

  // `this` will be the overall tooltip
  var position = this._chart.canvas.getBoundingClientRect()

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1
  tooltipEl.style.position = 'absolute'
  tooltipEl.style.left =
    position.left + window.pageXOffset + tooltipModel.caretX + 'px'
  tooltipEl.style.top =
    position.top + window.pageYOffset + tooltipModel.caretY + 'px'
  tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
  tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
  tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
  tooltipEl.style.padding =
    tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px'
  tooltipEl.style.pointerEvents = 'none'
}
